import { Heading, StyledFlex } from '@dreryk/react-components';

import { invoicePanelTranslationKeys } from '../translations';

import { InvoiceFiscalPrintIntegrationToggle } from './InvoiceFiscalPrintIntegrationToggle';
import { InvoiceFiscalPrintIntegrationToggleLoader } from './InvoiceFiscalPrintIntegrationToggle.loader';

export const InvoiceFiscalPrintIntegration = (): JSX.Element => {
   return (
      <StyledFlex direction={'column'}>
         <Heading content={invoicePanelTranslationKeys.fiscalPrintIntegration.header} testId={'heading'} type={'h2'} />
         <InvoiceFiscalPrintIntegrationToggleLoader>
            {({ fiscalPrintIntegrationEnabled }) => (
               <InvoiceFiscalPrintIntegrationToggle fiscalPrintIntegrationEnabled={fiscalPrintIntegrationEnabled} />
            )}
         </InvoiceFiscalPrintIntegrationToggleLoader>
      </StyledFlex>
   );
};
